import $ from "jquery";

export default {
    name: "echange-stock",
    components: {},
    props: [],
    data() {
        return {
            filtered_articles: [],
            destination_id: null,
            articles: [],
            valeur: "",
            loading: false,
        };
    },

    computed: {
        stocks() {
            return this.$store.getters["stocks"];
        },
        
        stock() {
            return this.$store.getters["stock"];
        },
    },

    mounted() {
        setTimeout(() => {
            $(".p-content").fadeIn();
        }, 500);
        this.$store.dispatch("getStock", this.$route.params.id);

        this.$store.dispatch("getStocks");
    },

    methods: {
        filter_article() {
            this.filtered_articles = [];

            if (this.valeur.length > 1) {
                this.stock.articles.forEach((element) => {
                    if (
                        element.libelle.toLowerCase().includes(this.valeur.toLowerCase())
                    ) {
                        this.filtered_articles.push(element);
                    }
                });
            }
        },

        choiceArticle(article) {
            let dosage =
                JSON.parse(article.attribut).Dosage != null
                    ? JSON.parse(article.attribut).Dosage
                    : "";
            let dosage_unite =
                JSON.parse(article.attribut)["Unité Dosage"] != null
                    ? JSON.parse(article.attribut)["Unité Dosage"]
                    : "";
            let forme =
                JSON.parse(article.attribut).Forme != null
                    ? JSON.parse(article.attribut).Forme
                    : "";
            dosage = " " + dosage + " " + dosage_unite + " ";

            this.articles.push({
                article: article.id,
                libelle: article.libelle + dosage + forme,
                nombre: null,
            });
            this.valeur = "";
            this.filtered_articles = [];
        },

        deleteArticle(index) {
            this.articles.splice(index, 1);
        },

        async submitForm() {
            const isValid = await this.$refs.observer.validate();

            if (!isValid) {
                console.log("error");
            } else {
                this.loading = true;

                const data = {
                    echanges: this.articles,
                    destination: this.destination_id,
                    depart: this.$route.params.id,
                };

                await this.$store.dispatch("saveEchange", data).then((response) => {
                    if (response) {
                        this.loading = false;
                        this.$router.push({ path: "/stock" });
                    } else {
                        this.loading = true;
                    }
                });
            }
        },
    },
};
